import Header from "@/pages/home/components/Header";
import Hero from "@/pages/home/components/Hero";
import Reasons from "@/pages/home/components/Reasons";
import Services from "@/pages/home/components/Services";
import Pricing from "@/pages/home/components/Pricing";
import Flow from "@/pages/home/components/Flow";
import Cases from "@/pages/home/components/Cases";
import Voices from "@/pages/home/components/Voices";
import Faq from "@/pages/home/components/Faq";
import Company from "@/pages/home/components/Company";
import Contact from "@/pages/home/components/Contact";
import Footer from "@/pages/home/components/Footer";
import StickyCta from "@/pages/home/components/StickyCta";

export default function Home() {
  return (
    <div className="w-full min-w-[320px] bg-background-50 text-foreground-950">
      <Header />
      <main>
        <Hero />
        <Reasons />
        <Services />
        <Pricing />
        <Flow />
        <Cases />
        <Voices />
        <Faq />
        <Company />
        <Contact />
      </main>
      <Footer />
      <StickyCta />
    </div>
  );
}